module.exports = __webpack_public_path__ + "static/img/PC-6.f5fdc8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/PC-6.png
// module id = qsLc
// module chunks = 0